import React from "react";
import {useDispatch} from "react-redux";
import {updateGuest} from "redux/actions/guestsActions";
import ChipIconText from "connectui/component/display/chip/ChipIconText";
import SvgIcon from "connectui/component/display/SvgIcon";
import {THEME} from "configuration/settings";
import {useTheme} from "connectui/theme/ThemeProvider";
import ICONS from "connectui/icons/iconMap";

export default function ChatbotToggleButton({guest}) {
  const dispatch = useDispatch();
  const {theme} = useTheme();

  const handleToggle = () => {
    dispatch(
      updateGuest({
        guest_id: guest.guest_id,
        field: "chatbot_enabled",
        val: !guest.chatbot_enabled,
        disableAlert: true,
      }),
    );
  };

  // All the sx are to make it look like EnsoAIButton and align with it
  return (
    <ChipIconText
      onClick={handleToggle}
      icon={
        <SvgIcon
          component={ICONS["send-autopilot"]}
          sx={{width: "18px", height: "18px"}}
        />
      }
      text={guest.chatbot_enabled ? "Disable Autopilot" : "Enable Autopilot"}
      textColor={THEME.AI.color}
      typographyVariant="textSM"
      weight="medium"
      sx={{
        color: THEME.AI.color,
        cursor: "pointer",
        border: `1px solid ${THEME.AI.color}80`,
        padding: theme.spacing(1, 3),
        backgroundColor: THEME.AI.bg,
        minWidth: "fit-content",
        height: "fit-content",
        fontWeight: "500",
        "&:hover": {
          backgroundColor: THEME.AI.hoverBG,
          border: `1px solid ${THEME.AI.color}`,
        },
      }}
    />
  );
}
